import css from "./blog.module.css";
import YouTube from "react-youtube";
import { useMemo, useState } from "react";
import { Link } from "react-router-dom";

export default function BlogView({ blogData, windowDimensions }) {
  const [showCount, setShowCount] = useState(6);

  const getArticleDateValue = (article) => {
    const date =
      article.timestamp ||
      article.createdAt ||
      article.createdDate ||
      article.date ||
      article.updatedAt;

    if (!date) return 0;

    if (date?.toDate) {
      return date.toDate().getTime();
    }

    return new Date(date).getTime() || 0;
  };

  const sortedBlogData = useMemo(() => {
    if (!Array.isArray(blogData)) return [];

    return [...blogData].sort(
      (a, b) => getArticleDateValue(b) - getArticleDateValue(a),
    );
  }, [blogData]);

  const handleShowMore = () => {
    setShowCount((prevCount) => prevCount + 6);
  };

  return (
    <div className={css.bigVideoWrap}>
      {sortedBlogData.length > 0 && (
        <div className={css.bigVideoWrapSmall}>
          <div className={css.bigWrap}>
            {windowDimensions && (
              <img
                className={css.bigImgBlog}
                src={sortedBlogData[0].photo}
                alt={sortedBlogData[0].zag}
              />
            )}

            {!windowDimensions && (
              <img
                className={css.bigImgBlog}
                src={sortedBlogData[0].photo}
                alt={sortedBlogData[0].zag}
              />
            )}

            <div className={css.someTextWrap}>
              {sortedBlogData[0].check && sortedBlogData[0].linkto ? (
                <a
                  href={sortedBlogData[0].linkto}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={css.videoViewvH1}
                >
                  {sortedBlogData[0].zag}
                </a>
              ) : (
                <Link
                  to={`/blog/${sortedBlogData[0].uid}`}
                  className={css.videoViewvH1}
                >
                  {sortedBlogData[0].zag}
                </Link>
              )}

              <p className={css.bigVideoP}>{sortedBlogData[0].chortDesc}</p>
            </div>
          </div>

          <div className={css.smallVideoWrap}>
            <div className={css.smallvidelListWrap}>
              {sortedBlogData.map((el, index) => {
                if (index < showCount) {
                  return (
                    <div
                      key={el.uid || el.id || index}
                      className={css.smalVideoPro}
                    >
                      {windowDimensions && (
                        <div className={css.imgWrapBorder}>
                          {el.check && el.linkto ? (
                            <a
                              href={el.linkto}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={el.photo}
                                className={css.smallImgBlog}
                                alt={el.zag}
                              />
                            </a>
                          ) : (
                            <Link to={`/blog/${el.uid}`}>
                              <img
                                src={el.photo}
                                className={css.smallImgBlog}
                                alt={el.zag}
                              />
                            </Link>
                          )}
                        </div>
                      )}

                      {!windowDimensions && (
                        <div className={css.imgWrapBorder}>
                          {el.check && el.linkto ? (
                            <a
                              href={el.linkto}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={el.photo}
                                className={css.smallImgBlog}
                                alt={el.zag}
                              />
                            </a>
                          ) : (
                            <Link to={`/blog/${el.uid}`}>
                              <img
                                src={el.photo}
                                className={css.smallImgBlog}
                                alt={el.zag}
                              />
                            </Link>
                          )}
                        </div>
                      )}

                      {el.check && el.linkto ? (
                        <a
                          href={el.linkto}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={css.videoName}
                        >
                          {el.zag}
                        </a>
                      ) : (
                        <Link to={`/blog/${el.uid}`} className={css.videoName}>
                          {el.zag}
                        </Link>
                      )}

                      <p className={css.videoNameDesc}>{el.chortDesc}</p>
                    </div>
                  );
                }

                return null;
              })}
            </div>
          </div>

          {showCount < sortedBlogData.length && (
            <button className={css.mareVideo} onClick={handleShowMore}>
              Більше статей
            </button>
          )}
        </div>
      )}
    </div>
  );
}
